import { render, staticRenderFns } from "./top-up-bills.vue?vue&type=template&id=cb8e5c3a&scoped=true&"
import script from "./top-up-bills.vue?vue&type=script&lang=js&"
export * from "./top-up-bills.vue?vue&type=script&lang=js&"
import style0 from "./top-up-bills.vue?vue&type=style&index=0&id=cb8e5c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8e5c3a",
  null
  
)

export default component.exports